import React, { useContext } from 'react'
import RmdSelectionControlGroup, { SelectionControlGroupProps } from 'react-md/lib/SelectionControls/SelectionControlGroup'
import UncheckedCheckboxIcon from 'assets/icons/checkbox-unchecked.svg'
import UncheckedRadioIcon from 'assets/icons/radio-unchecked.svg'
import styled, { ThemeContext } from 'styled-components'
import SvgRadioCheckedIcon from 'assets/icons/RadioChecked'

type ControlGroupProps = SelectionControlGroupProps & { direction?: string }
const SelectionControlGroup: React.FC<ControlGroupProps> = (props: ControlGroupProps) => {
  const theme = useContext(ThemeContext)

  return (
    <StyledSelectionControlGroup
      {...props}
      checkedRadioIcon={<SvgRadioCheckedIcon fill={theme.colors.main} />}
      uncheckedCheckboxIcon={<img src={UncheckedCheckboxIcon} />}
      uncheckedRadioIcon={<img src={UncheckedRadioIcon} />}
    />
  )
}

const StyledSelectionControlGroup = styled(RmdSelectionControlGroup)<ControlGroupProps>`
  display: flex;
  margin: 0;
  padding: 0;

  .md-selection-control-container {
    height: 20px;
  
    &:not(:last-child) {
      ${({ direction }) => direction === 'column' ? 'margin-bottom: 10px;' : 'margin-right: 40px;'}
    }
  }

  .md-selection-control-toggle {
    margin-right: 10px;
    width: 18px;
    height: 18px;
    padding: 0;
  }

  span {
    font-size: 16px;
    height: 20px;
  }

  legend {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: ${({ theme }) => theme.colors.secondary};
  }

  ${({ direction }) => `
    flex-direction: ${direction};
  `}
`

export default SelectionControlGroup